import {parseSearchString} from "../../../utils/convertation/parseSearchString";

export const iterateCheckboxes = ( chooser, query ) => {
	Array.from( chooser.querySelectorAll( 'li.checkbox:not(.disabled)' ) ).forEach( ( it ) => {
		const name = it.dataset.for;
		const input = it.querySelector( 'input' );
		const search = parseSearchString( location.search );

		if ( input.dataset.disabledIfChecked )
		{
			if ( input.checked )
			{
				chooser.querySelector( `li[data-for="${input.dataset.disabledIfChecked}"]` ).classList.add( 'disabled' );
			}
			else
			{
				chooser.querySelector( `li[data-for="${input.dataset.disabledIfChecked}"]` ).classList.remove( 'disabled' );
			}
		}

		if ( input.checked )
		{
			if ( search[name] )
			{
				input.classList.add( 'user-changed' );
			}
			
			if ( input.classList.contains( 'user-changed' ) )
			{
				query.userChanged += `,${name}`;
			}
			
			if ( query.search !== '' )
			{
				query.search += '&';
			}
			
			query.search += name;
		}
	} );
};